var changeCase = require('change-case')

const List = () => import('../components/List').then(m => m.default || m)
const AutoForm = () => import('../components/AutoForm').then(m => m.default || m)
const Step = require('../pages/step')

const FrontList = require('../pages/list')

export default [
    // Welcome
    {
        path: '/',
        name: 'welcome',
        component: () => import('../pages/welcome').then(m => m.default || m)
    },

    // Auth
    {
        path: '/login',
        name: 'login',
        component: () => import('../pages/auth/login').then(m => m.default || m)
    },

    {
        path: '/sms-code-validation',
        name: 'smsCodeValidation',
        component: () => import('../pages/auth/smsCodeValidation').then(m => m.default || m),
        props: true
    },

    // {
    //     path: '/password/reset',
    //     name: 'password.request',
    //     component: () => import('../pages/auth/password/reset').then(m => m.default || m)
    // },
    // {
    //     path: '/password/reset/:token',
    //     name: 'password.reset',
    //     component: () => import('../pages/auth/password/email').then(m => m.default || m)
    // },

    // Home
    {
        path: '/home',
        name: 'home',
        component: () => import('../pages/home').then(m => m.default || m)
    },

    {
        path: '/home/:menuItem?',
        name: 'home.children',
        component: () => import('../pages/home').then(m => m.default || m),
        props: {
            showChildrens: true
        }
    },
    {
        path: '/orders/in-dunning',
        name: 'orders.in-dunning',
        component: FrontList,
        meta: {
            roles: ['Backoffice', 'Admin', 'Reverse Dunning Process']
        },
        props: {
            slug: 'orders/in-dunning',
            singular: 'order in dunning',
            plural: 'orders in dunning',
            icon: 'how to reg',
            columnsDef: 'orderDunningColumns',
            detailComp: 'order-dunning-detail'
        }
    },

    // User settings
    {
        path: '/settings',
        component: () => import('../pages/settings/index').then(m => m.default || m),
        children: [
            {
                path: '',
                redirect: {name: 'settings.profile'}
            },
            {
                path: 'profile',
                name: 'settings.profile',
                component: () => import('../pages/settings/profile').then(m => m.default || m)
            },
            // {
            //     path: 'password',
            //     name: 'settings.password',
            //     component: () => import('../pages/settings/password').then(m => m.default || m)
            // }
        ]
    },

    // Admin
    {
        path: '/admin',
        component: Step,
        children: [
        ]
            .concat(makeCRUDsRoutes('admin', [
                'Configuration',
                'LendingPointType',
                'ConsumerType',
                'NoSoldReason',
                'OrderStatus',
                'Origin',
                'Role',
                'StockStatus',
                'User',
                'Audit',
                'SentSms',
                'StockOrderStatus',
                'StockOperation',
                'EmailTemplate',
                'Whitelist',
                'SmsTemplate',
                'ChangeDeviceEmail',
                'PersonalAccessToken'
            ], { role: 'Admin' }))
    },

    // Backoffice
    {
        path: '/backoffice',
        component: Step,
        children: [
            {
                path: 'lending-kit-model',
                name: 'backoffice.lending-kit-model.index',
                meta: {
                    roles: ['Backoffice', 'Admin']
                },
                component: () => import('../pages/backoffice/lending-kit-model/index.vue'),
                props: {
                    slug: 'lending-kit-model',
                    baseRoute: 'backoffice.lending-kit-model'
                }
            },
            {
                path: 'lending-point/form',
                name: 'backoffice.lending-point.create',
                meta: {
                    roles: ['Admin', 'Backoffice', 'Lending Point Backoffice']
                },
                component: () => import('../pages/lending-point/form'),
                props: {
                    slug: 'lending-point',
                    baseRoute: 'backoffice.lending-point'
                }
            },
            {
                path: 'lending-point/form/:id',
                name: 'backoffice.lending-point.edit',
                meta: {
                    roles: ['Admin', 'Backoffice', 'Lending Point Backoffice']
                },
                component: () => import('../pages/lending-point/form'),
                props: {
                    slug: 'lending-point',
                    baseRoute: 'backoffice.lending-point'
                }
            },
            {
                path: 'lending-point/export',
                name: 'backoffice.lending-point.export',
                meta: {
                    roles: ['Admin', 'Backoffice', 'Lending Point Backoffice'],
                    checkExport: true
                },
                component: () => import('../pages/backoffice/lending-point/export').then(m => m.default || m)
            },
            {
                path: 'lending-point/import',
                name: 'backoffice.lending-point.import',
                meta: {
                    roles: ['Admin', 'Backoffice', 'Lending Point Backoffice']
                },
                component: () => import('../pages/backoffice/lending-point/import').then(m => m.default || m)
            },
            {
                path: 'lending-point/import-model',
                name: 'backoffice.lending-point.import-model',
                meta: {
                    roles: ['Admin', 'Backoffice']
                },
                component: () => import('../pages/backoffice/lending-point/import-model').then(m => m.default || m)
            },
            {
                path: 'lending-point/import-sku',
                name: 'backoffice.lending-point.import-sku',
                meta: {
                    roles: ['Admin', 'Backoffice']
                },
                component: () => import('../pages/backoffice/lending-point/import-sku').then(m => m.default || m)
            },
            {
                path: 'user/export',
                name: 'backoffice.user.export',
                meta: {
                    roles: ['Admin', 'Backoffice', 'Lending Point Backoffice'],
                    checkExport: true
                },
                component: () => import('../pages/backoffice/user/export').then(m => m.default || m)
            },
            {
                path: 'lending-kit/export',
                name: 'backoffice.lending-kit.export',
                meta: {
                    roles: ['Admin', 'Backoffice'],
                    checkExport: true
                },
                component: () => import('../pages/backoffice/lending-kit/export').then(m => m.default || m)
            },
            {
                path: 'lending-kit/import',
                name: 'backoffice.lending-kit.import',
                meta: {
                    roles: ['Admin', 'Backoffice']
                },
                component: () => import('../pages/backoffice/lending-kit/import').then(m => m.default || m)
            },
            {
                path: 'lending-kit-iqos/import',
                name: 'backoffice.lending-kit-iqos.import',
                meta: {
                    roles: ['Admin', 'Backoffice']
                },
                component: () => import('../pages/backoffice/lending-kit-iqos/import').then(m => m.default || m)
            },
            {
                path: 'lending-kit-iqos/export',
                name: 'backoffice.lending-kit-iqos.export',
                meta: {
                    roles: ['Admin', 'Backoffice'],
                    checkExport: true
                },
                component: () => import('../pages/backoffice/lending-kit-iqos/export').then(m => m.default || m)
            },
            {
                path: 'order/export',
                name: 'backoffice.order.export',
                meta: {
                    roles: ['Admin', 'Backoffice'],
                    checkExport: true
                },
                component: () => import('../pages/backoffice/order/export').then(m => m.default || m)
            },
            {
                path: 'audit/export',
                name: 'backoffice.audit.export',
                meta: {
                    roles: ['Admin', 'Backoffice']
                },
                component: () => import('../pages/backoffice/audit/export').then(m => m.default || m)
            },
            {
                path: 'sent-sms/export',
                name: 'backoffice.sent-sms.export',
                meta: {
                    roles: ['Admin', 'Backoffice']
                },
                component: () => import('../pages/backoffice/sent-sms/export').then(m => m.default || m)
            },
            {
                path: 'order-movement/export',
                name: 'backoffice.order-movement.export',
                meta: {
                    roles: ['Admin', 'Backoffice'],
                    checkExport: true
                },
                component: () => import('../pages/backoffice/order-movement/export').then(m => m.default || m)
            },
            {
                path: 'stock-management/export',
                name: 'backoffice.stock-management.export',
                meta: {
                    roles: ['Admin', 'Backoffice'],
                    checkExport: true
                },
                component: () => import('../pages/backoffice/stock-management/export').then(m => m.default || m)
            },
            {
                path: 'stock-management/form/:id',
                name: 'backoffice.stock-management.edit',
                meta: {
                    roles: ['Backoffice', 'Admin']
                },
                component: () => import('../pages/backoffice/stock-management/stock-management'),
                props: {
                    slug: 'stock-management',
                    baseRoute: 'backoffice.stock-management'
                }
            },
            // {
            //     path: 'stock-management/',
            //     name: 'backoffice.stock-management.index',
            //     meta: {
            //         roles: ['Admin', 'Backoffice']
            //     },
            //     component: () => import('../pages/backoffice/stock-management/index').then(m => m.default || m)
            // },
            {
                path: 'stock-order',
                name: 'backoffice.stock-order',
                meta: {
                    roles: ['Admin', 'Backoffice']
                },
                component: () => import('../pages/backoffice/stock-order/stock-order').then(m => m.default || m)
            },
            {
                path: 'stock-orders',
                name: 'backoffice.stock-orders',
                component: FrontList,
                meta: {
                    roles: ['Admin', 'Backoffice']
                },
                props: {
                    slug: 'stock-orders',
                    singular: 'stock order',
                    plural: 'stock orders',
                    icon: 'shopping_cart',
                    columnsDef: 'stockOrderColumns',
                    detailComp: 'stock-order-detail',
                    exportStockOrders: 'backoffice.stock-order.export',
                    exportChangeStatusRoute: 'backoffice.stock-order-change-status.export',
                }
            },
            {
                path: 'stock-order/export/',
                name: 'backoffice.stock-order.export',
                meta: {
                    roles: ['Backoffice', 'Admin'],
                    checkExport: true
                },
                component: () => import('../pages/backoffice/stock-order/export').then(m => m.default || m)
            },
            {
                path: 'stock-order/import',
                name: 'backoffice.stock-order.import',
                meta: {
                    roles: ['Backoffice']
                },
                component: () => import('../pages/backoffice/stock-order/import').then(m => m.default || m)
            },
            {
                path: 'lending-kit-model',
                name: 'backoffice.lending-kit-model.index',
                meta: {
                    roles: ['Backoffice', 'Admin']
                },
                component: () => import('../pages/backoffice/lending-kit-model/index.vue'),
                props: {
                    slug: 'lending-kit-model',
                    baseRoute: 'backoffice.lending-kit-model'
                },
            },
            {
                path: 'stock-order-change-status/export/',
                name: 'backoffice.stock-order-change-status.export',
                meta: {
                    roles: ['Backoffice', 'Admin'],
                    checkExport: true
                },
                component: () => import('../pages/backoffice/stock-order-change-status/export').then(m => m.default || m)
            },
        ]
            .concat(makeCRUDsRoutes('backoffice',[
                'LendingPoint',
            ], { roles: ['Admin', 'Backoffice', 'Lending Point Backoffice'] }))
            .concat(makeCRUDsRoutes('backoffice',[
                'LendingKit',
                'Order',
                'OrderMovement',
                'Origin',
                'StockMovement',
                'LendingKitUpload',
                'StockManagement',
                'User',
                'LendingKitModel',
                'LendingKitColor',
                'OrderErrorDcs',
                'ChangeDeviceEmail',
                'StockOrderChangeStatus'
            ], { roles: ['Admin', 'Backoffice'] }))
    },
    {
        path: 'lending-kit/update-import',
        name: 'backoffice.lending-kit.update-import',
        meta: {
            roles: ['Admin', 'Backoffice']
        },
        component: () => import('../pages/backoffice/lending-kit/import-update').then(m => m.default || m)
    },
    {
        path: 'stock-movement/export',
        name: 'backoffice.stock-movement.export',
        meta: {
            roles: ['Admin', 'Backoffice'],
            checkExport: true
        },
        component: () => import('../pages/backoffice/stock-movement/export').then(m => m.default || m)
    },
    {
        path: 'order/change-status/completed-not-returned',
        name: 'backoffice.order.change-status.completed-not-returned',
        meta: {
            roles: ['Admin', 'Backoffice']
        },
        component: () => import('../pages/backoffice/order/changeStatusCompletedNotReturned').then(m => m.default || m)
    },    
    {
        path: '/lending-kit-model/color/form',
        name: 'lending-kit-model/color.create',
        meta: {
            roles: ['Backoffice', 'Admin']
        },
        component: () => import('../pages/lending-kit-color/form.vue').then(m => m.default || m),
        props: {
            slug: 'lending-kit-color-custom',
            baseRoute: 'lending-kit-color-custom'
        }
    },
    {
        path: '/lending-kit-model/color/form/:id',
        name: 'lending-kit-model/color.edit',
        meta: {
            roles: ['Backoffice', 'Admin']
        },
        component: () => import('../pages/lending-kit-color/form.vue').then(m => m.default || m),
        props: {
            slug: 'lending-kit-color-custom',
            baseRoute: 'lending-kit-color-custom'
        }
    },

    {
        path: '/lending-kit-model/color',
        redirect: { name: 'backoffice.lending-kit-model.index' }
    },

    // Call Center
    {
        path: '/call-center',
        component: Step,
        children: [
            {
                path: 'order',
                name: 'call-center.order',
                meta: {
                    roles: ['Call Center']
                },
                component: () => import('../pages/call-center/order').then(m => m.default || m)
            },
            {
                path: 'orders',
                name: 'call-center.orders',
                component: FrontList,
                meta: {
                    roles: ['Call Center']
                },
                props: {
                    plural: 'orders history',
                    singular: 'order',
                    slug: 'call-center/orders',
                    icon: 'shopping cart',
                    columnsDef: 'orderColumns',
                    detailComp: 'order-detail',
                    createRoute: 'call-center.order'
                }
            },
            {
                path: 'orders/due',
                name: 'call-center.orders.due',
                component: FrontList,
                meta: {
                    roles: ['Call Center']
                },
                props: {
                    plural: 'lendings > 15 days',
                    singular: 'lending > 15 days',
                    slug: 'call-center/orders/due',
                    icon: 'alarm off',
                    columnsDef: 'orderColumns',
                    detailComp: 'order-detail',
                    createRoute: 'call-center.order'
                }
            },
            {
                path: 'orders/more-than-30',
                name: 'call-center.orders.more-than-30',
                component: FrontList,
                meta: {
                    roles: ['Call Center']
                },
                props: {
                    plural: 'lendings > 30 days',
                    singular: 'lending > 30 days',
                    slug: 'call-center/orders/more-than-30',
                    icon: 'alarm off',
                    columnsDef: 'orderColumns',
                    detailComp: 'order-detail',
                    createRoute: 'call-center.order'
                }
            },
            {
                path: 'orders/will-due',
                name: 'call-center.orders.will-due',
                component: FrontList,
                meta: {
                    roles: ['Call Center']
                },
                props: {
                    plural: 'lendings that will due',
                    singular: 'lending that will due',
                    slug: 'call-center/orders/will-due',
                    icon: 'alarm',
                    columnsDef: 'orderColumns',
                    detailComp: 'order-detail',
                    createRoute: 'call-center.order'
                }
            },
            {
                path: 'orders/closed-earlier',
                name: 'call-center.orders.closed-earlier',
                component: FrontList,
                meta: {
                    roles: ['Call Center']
                },
                props: {
                    plural: 'orders closed before 15 days',
                    singular: 'order closed before 15 days',
                    slug: 'call-center/orders/closed-earlier',
                    icon: 'history',
                    columnsDef: 'orderColumns',
                    detailComp: 'order-detail',
                    createRoute: 'call-center.order'
                }
            },
            {
                path: 'consumer-registration',
                meta: {
                    roles: ['Call Center']
                },
                name: 'call-center.consumer-registration',
                component: () => import('../pages/call-center/consumer-registration').then(m => m.default || m)
            },
        ]
            .concat(makeCRUDsRoutes('call-center',[
                'LendingKit',
                'LendingPoint'
            ], { roles: ['Call Center'] }))
    },

    // Lending Point
    {
        path: '/lending-point',
        component: Step,
        children: [
            {
                path: 'order',
                name: 'lending-point.order',
                meta: {
                    roles: ['Lending Point', 'Lending Point Indirect', 'Lending Point Hostesses'],
                    mustBeActive: 1
                },
                component: () => import('../pages/lending-point/order').then(m => m.default || m)
            },
            {
                path: 'order/:id',
                name: 'lending-point.order-detail',
                meta: {
                    roles: ['Lending Point', 'Lending Point Indirect'],
                },
                component: () => import('../pages/_orderDetail').then(m => m.default || m)
            },
            {
                path: 'orders',
                name: 'lending-point.orders',
                component: FrontList,
                meta: {
                    roles: ['Lending Point', 'Lending Point Indirect'],
                },
                props: {
                    slug: 'lending-point/orders',
                    singular: 'order',
                    plural: 'orders history',
                    icon: 'shopping_cart',
                    columnsDef: 'orderColumns',
                    detailComp: 'order-detail',
                    createRoute: 'lending-point.order'
                }
            },
            {
                path: 'orders-hostess',
                name: 'lending-point-hostesses.orders',
                component: FrontList,
                meta: {
                    roles: ['Lending Point Hostesses'],
                },
                props: {
                    slug: 'lending-point/orders',
                    singular: 'order-host',
                    plural: 'orders history',
                    icon: 'shopping_cart',
                    columnsDef: 'orderHostessesColumns',
                    detailComp: 'order-detail',
                    createRoute: 'lending-point-hostesses.order'
                }
            },
            {
                path: 'orders/reserved',
                name: 'lending-point.orders.reserved',
                component: FrontList,
                meta: {
                    roles: ['Lending Point', 'Lending Point Indirect'],
                    mustBeActive: 1
                },
                props: {
                    slug: 'lending-point/orders/reserved',
                    singular: 'call center reserved order',
                    plural: 'call center reserved orders',
                    icon: 'star',
                    columnsDef: 'orderColumns',
                    detailComp: 'order-detail',
                    createRoute: 'lending-point.order'
                }
            },
            {
                path: 'orders/in-lending',
                name: 'lending-point.orders.in-lending',
                component: FrontList,
                meta: {
                    roles: ['Lending Point', 'Lending Point Indirect', 'Lending Point Hostesses'],
                    mustBeActive: 1
                },
                props: {
                    slug: 'lending-point/orders/in-lending',
                    singular: 'order in lending',
                    plural: 'orders in lending',
                    icon: 'how to reg',
                    columnsDef: 'orderColumns',
                    detailComp: 'order-detail',
                    createRoute: 'lending-point.order'
                }
            },
            {
                path: 'lending-kits',
                name: 'lending-point.lending-kits',
                component: FrontList,
                meta: {
                    roles: ['Lending Point', 'Lending Point Indirect', 'Lending Point Hostesses'],
                    mustBeActive: 1
                },
                props: {
                    slug: 'lending-point/lending-kits',
                    singular: 'lending kit',
                    plural: 'lending kits stock',
                    icon: 'how_to_vote',
                    columnsDef: 'lendingKitColumns',
                    detailComp: 'lending-kit-detail'
                }
            },
            {
                path: 'lending-kits/cleaning',
                name: 'lending-point.lending-kits.cleaning',
                component: FrontList,
                meta: {
                    roles: ['Lending Point', 'Lending Point Indirect', 'Lending Point Hostesses'],
                    mustBeActive: 1
                },
                props: {
                    slug: 'lending-point/lending-kits/cleaning',
                    singular: 'lending kits for maintenance',
                    plural: 'lending kit for maintenance',
                    icon: 'phonelink_setup',
                    columnsDef: 'lendingKitColumns',
                }
            },
            {
                path: 'stock-order/good-receipt',
                name: 'lending-point.stock-order.good-receipt',
                meta: {
                    roles: ['Lending Point', 'Lending Point Indirect', 'Lending Point Hostesses', 'Backoffice', 'Admin']
                },
                component: () => import('../pages/lending-point/goodReceipt').then(m => m.default || m),
                props: {
                    slug: 'lending-point/stock-order/good-receipt',
                    singular: 'good receipt',
                    plural: 'good receipt',
                    icon: 'move_to_inbox',
                }
            },
            {
                path: '/ending-lending',
                name: 'lending-point.ending-lending',
                meta: {
                    roles: ['Lending Point', 'Lending Point Indirect'],
                    mustBeActive: 1
                },
                component: () => import('../pages/lending-point/endingLending').then(m => m.default || m),
                props: {
                    slug: 'lending-point/ending-lending',
                    singular: 'ending lending',
                    plural: 'ending lending',
                    icon: 'assignment late',
                }
            }
        ]

    },

    // Iqos Coach
    {
        path: '/iqos-coach',
        component: Step,
        children: [
            {
                path: 'order',
                name: 'iqos-coach.order',
                meta: {
                    roles: ['Iqos Coach']
                },
                component: () => import('../pages/iqos-coach/order').then(m => m.default || m)
            },
            {
                path: 'orders',
                name: 'iqos-coach.orders',
                component: FrontList,
                meta: {
                    roles: ['Iqos Coach']
                },
                props: {
                    slug: 'iqos-coach/orders',
                    singular: 'order',
                    plural: 'orders history',
                    icon: 'shopping_cart',
                    columnsDef: 'orderColumns',
                    detailComp: 'order-detail',
                    createRoute: 'iqos-coach.order'
                }
            },
            {
                path: 'orders/reserved',
                name: 'iqos-coach.orders.reserved',
                component: FrontList,
                meta: {
                    roles: ['Iqos Coach']
                },
                props: {
                    slug: 'iqos-coach/orders/reserved',
                    singular: 'call center reserved order',
                    plural: 'call center reserved orders',
                    icon: 'star',
                    columnsDef: 'orderColumns',
                    detailComp: 'order-detail',
                    createRoute: 'iqos-coach.order'
                }
            },
            {
                path: 'orders/in-lending',
                name: 'iqos-coach.orders.in-lending',
                component: FrontList,
                meta: {
                    roles: ['Iqos Coach']
                },
                props: {
                    slug: 'iqos-coach/orders/in-lending',
                    singular: 'order in lending',
                    plural: 'orders in lending',
                    icon: 'how to reg',
                    columnsDef: 'orderCoachColumns',
                    detailComp: 'order-detail',
                    createRoute: 'iqos-coach.order'
                }
            },
            {
                path: 'lending-kits',
                name: 'iqos-coach.lending-kits',
                component: FrontList,
                meta: {
                    roles: ['Iqos Coach']
                },
                props: {
                    slug: 'iqos-coach/lending-kits',
                    singular: 'lending kit',
                    plural: 'lending kits stock',
                    icon: 'how_to_vote',
                    columnsDef: 'lendingKitColumns',
                    detailComp: 'lending-kit-detail'
                }
            },
            {
                path: 'iqos-coach/cleaning',
                name: 'iqos-coach.lending-kits.cleaning',
                component: FrontList,
                meta: {
                    roles: ['Iqos Coach']
                },
                props: {
                    slug: 'iqos-coach/lending-kits/cleaning',
                    singular: 'lending kits for maintenance',
                    plural: 'lending kit for maintenance',
                    icon: 'phonelink_setup',
                    columnsDef: 'lendingKitColumns'
                }
            },
            {
                path: 'stock-order/good-receipt',
                name: 'iqos-coach.stock-order.good-receipt',
                meta: {
                    roles: ['Iqos Coach']
                },
                component: () => import('../pages/iqos-coach/goodReceipt').then(m => m.default || m),
                props: {
                    slug: 'iqos-coach/stock-order/good-receipt',
                    singular: 'good receipt',
                    plural: 'good receipt',
                    icon: 'move_to_inbox',
                }
            },
            {
                path: 'orders/pending-pickup',
                name: 'iqos-coach.orders.pending-pickup',
                component: FrontList,
                meta: {
                    roles: ['Iqos Coach']
                },
                props: {
                    slug: 'iqos-coach/orders/pending-pickup',
                    singular: 'pending pickup order',
                    plural: 'pending pickup orders',
                    icon: 'undo',
                    columnsDef: 'orderColumns',
                    detailComp: 'order-detail'
                }
            },
        ]
    },

    // Courier
    {
        path: '/courier',
        component: Step,
        children: [
            {
                path: 'stock-orders',
                name: 'courier.stock-orders',
                component: FrontList,
                meta: {
                    roles: ['Courier']
                },
                props: {
                    slug: 'courier/stock-orders',
                    singular: 'stock order',
                    plural: 'stock orders',
                    icon: 'shopping_cart',
                    columnsDef: 'stockOrderColumns',
                    detailComp: 'stock-order-detail',
                    exportRoute: 'courier.stock-order.export',
                    exportParams: { scope: 'onMyLendingPoint'}
                }
            },
            {
                path: 'stock-orders/pending-delivery',
                name: 'courier.stock-orders.pending-delivery',
                component: FrontList,
                meta: {
                    roles: ['Courier']
                },
                props: {
                    slug: 'courier/stock-orders/pending-delivery',
                    singular: 'delivery order',
                    plural: 'delivery orders',
                    icon: 'star',
                    columnsDef: 'stockOrderColumns',
                    detailComp: 'stock-order-detail',
                    exportRoute: 'courier.stock-order.export',
                    exportParams: { scope: 'pendingDelivery'}

                }
            },
            {
                path: 'stock-orders/in-transit-delivery',
                name: 'courier.stock-orders.in-transit.delivery',
                component: FrontList,
                meta: {
                    roles: ['Courier']
                },
                props: {
                    slug: 'courier/stock-orders/in-transit-delivery',
                    singular: 'in transit - delivery',
                    plural: 'in transit - delivery',
                    icon: 'motorcycle',
                    columnsDef: 'stockOrderColumns',
                    detailComp: 'stock-order-detail',
                    exportRoute: 'courier.stock-order.export',
                    exportParams: { scope: 'InTransitDelivery'}
                }
            },
            {
                path: 'stock-orders/in-transit-pickup',
                name: 'courier.stock-orders.in-transit.pickup',
                component: FrontList,
                meta: {
                    roles: ['Courier']
                },
                props: {
                    slug: 'courier/stock-orders/in-transit-pickup',
                    singular: 'in transit - pickup',
                    plural: 'in transit - pickup',
                    icon: 'motorcycle',
                    columnsDef: 'stockOrderColumns',
                    detailComp: 'stock-order-detail',
                    exportRoute: 'courier.stock-order.export',
                    exportParams: { scope: 'InTransitPickup'}

                }
            },
            {
                path: 'stock-orders/pending-pickup',
                name: 'courier.stock-orders.pending-pickup',
                component: FrontList,
                meta: {
                    roles: ['Courier']
                },
                props: {
                    slug: 'courier/stock-orders/pending-pickup',
                    singular: 'pending pickup order',
                    plural: 'pending pickup orders',
                    icon: 'undo',
                    columnsDef: 'stockOrderColumns',
                    detailComp: 'stock-order-detail',
                    exportRoute: 'courier.stock-order.export',
                    exportParams: { scope: 'pendingPickup'}

                }
            },
            {
                path: 'stock-order/export/:scope?',
                name: 'courier.stock-order.export',
                meta: {
                    roles: ['Courier', 'Backoffice']
                },
                component: () => import('../pages/courier/stock-order/export').then(m => m.default || m)
            },
            {
                path: 'stock-management/export/:scope?',
                name: 'backoffice.stock-management.export',
                meta: {
                    roles: ['Backoffice','Admin']
                },
                component: () => import('../pages/courier/stock-order/export').then(m => m.default || m)
            },

            {
                path: 'orders',
                name: 'courier.orders',
                component: FrontList,
                meta: {
                    roles: ['Courier']
                },
                props: {
                    slug: 'courier/orders',
                    singular: 'order',
                    plural: 'orders history',
                    icon: 'shopping_cart',
                    columnsDef: 'orderColumns',
                    detailComp: 'order-detail',
                    exportRoute: 'courier.orders.export',
                }
            },
            {
                path: 'orders/reserved',
                name: 'courier.orders.reserved',
                component: FrontList,
                meta: {
                    roles: ['Courier']
                },
                props: {
                    slug: 'courier/orders/reserved',
                    singular: 'delivery order',
                    plural: 'delivery orders',
                    icon: 'star',
                    columnsDef: 'orderColumns',
                    detailComp: 'order-detail',
                    exportRoute: 'courier.orders.export',
                    exportParams: {
                        scope: 'reserved'
                    }
                }
            },
            /* {
                path: 'orders/in-transit',
                name: 'courier.orders.in-transit',
                component: FrontList,
                meta: {
                    roles: ['Courier']
                },
                props: {
                    slug: 'courier/orders/in-transit',
                    singular: 'in transit order',
                    plural: 'in transit orders',
                    icon: 'motorcycle',
                    columnsDef: 'orderColumns',
                    detailComp: 'order-detail'
                }
            },*/
            {
                path: 'orders/pending-pickup',
                name: 'courier.orders.pending-pickup',
                component: FrontList,
                meta: {
                    roles: ['Courier']
                },
                props: {
                    slug: 'courier/orders/pending-pickup',
                    singular: 'pending pickup order',
                    plural: 'pending pickup orders',
                    icon: 'undo',
                    columnsDef: 'orderColumns',
                    detailComp: 'order-detail',
                    exportRoute: 'courier.orders.export',
                    exportParams: {
                        scope: 'pendingPickup'
                    }
                }
            },
            {
                path: 'lending-kits',
                name: 'courier.lending-kits',
                component: FrontList,
                meta: {
                    roles: ['Courier']
                },
                props: {
                    slug: 'courier/lending-kits',
                    singular: 'lending kit',
                    plural: 'lending kits stock',
                    icon: 'how_to_vote',
                    columnsDef: 'lendingKitColumns',
                    detailComp: 'lending-kit-detail',
                    exportRoute: 'courier.lending-kit.export',
                    exportParams: { scope: 'onMyLendingPoint'},
                }
            },
            {
                path: 'lending-kits/cleaning',
                name: 'courier.lending-kits.cleaning',
                component: FrontList,
                meta: {
                    roles: ['Courier']
                },
                props: {
                    slug: 'courier/lending-kits/cleaning',
                    singular: 'lending kit for maintenance',
                    plural: 'lending kits for maintenance',
                    icon: 'phonelink_setup',
                    columnsDef: 'lendingKitColumns',
                    detailComp: 'lending-kit-detail',
                    exportRoute: 'courier.lending-kit.export',
                    exportParams: { scope: 'cleaningOnMyLendingPoint'},
                }
            },
            {
                path: 'lending-kits/available',
                name: 'courier.lending-kits.available',
                component: FrontList,
                meta: {
                    roles: ['Courier']
                },
                props: {
                    slug: 'courier/lending-kits/available',
                    singular: 'available lending kit',
                    plural: 'available lending kits',
                    icon: 'phonelink_setup',
                    columnsDef: 'lendingKitColumns',
                    detailComp: 'lending-kit-detail',
                    exportRoute: 'courier.lending-kit.export',
                    exportParams: { scope: 'availableOnMyLendingPoint'},
                    importRoute: 'courier.lending-kit.import',

                }
            },
            {
                path: 'lending-kits/broken',
                name: 'courier.lending-kits.broken',
                component: FrontList,
                meta: {
                    roles: ['Courier']
                },
                props: {
                    slug: 'courier/lending-kits/broken',
                    singular: 'broken lending kit',
                    plural: 'broken lending kits',
                    icon: 'how_to_vote',
                    columnsDef: 'lendingKitColumns',
                    detailComp: 'lending-kit-detail',
                    exportRoute: 'courier.lending-kit.export',
                    exportParams: { scope: 'brokenOnMyLendingPoint'},
                }
            },
            {
                path: 'lending-kit/export/:scope?',
                name: 'courier.lending-kit.export',
                meta: {
                    roles: ['Courier']
                },
                component: () => import('../pages/courier/lending-kit/export').then(m => m.default || m)
            },
            {
                path: 'lending-kit/import',
                name: 'courier.lending-kit.import',
                meta: {
                    roles: ['Courier']
                },
                component: () => import('../pages/backoffice/lending-kit/import').then(m => m.default || m)
            },
            {
                path: 'orders/in-transit-pickup',
                name: 'courier.orders.in-transit-pickup',
                component: FrontList,
                meta: {
                    roles: ['Courier']
                },
                props: {
                    slug: 'courier/orders/in-transit-pickup',
                    singular: 'in transit - pickup order',
                    plural: 'in transit - pickup orders',
                    icon: 'motorcycle',
                    columnsDef: 'orderColumns',
                    detailComp: 'order-detail',
                    exportRoute: 'courier.orders.export',
                    exportParams: {
                        scope: 'inTransitPickup'
                    }
                }
            },
            {
                path: 'orders/in-transit-delivery',
                name: 'courier.orders.in-transit-delivery',
                component: FrontList,
                meta: {
                    roles: ['Courier']
                },
                props: {
                    slug: 'courier/orders/in-transit-delivery',
                    singular: 'in transit - delivery order',
                    plural: 'in transit - delivery orders',
                    icon: 'motorcycle',
                    columnsDef: 'orderColumns',
                    detailComp: 'order-detail',
                    exportRoute: 'courier.orders.export',
                    exportParams: {
                        scope: 'inTransitDelivery'
                    }
                }
            },
            {
                path: 'orders/export/:scope?',
                name: 'courier.orders.export',
                meta: {
                    roles: ['Courier']
                },
                component: () => import('../pages/courier/order/export').then(m => m.default || m)
            },

        ]
    },
    // Devices
    {
        path: '/device',
        name: 'device',
        component: () => import('../pages/device/importDevices').then(m => m.default || m)
    },

    // Audit
    {
        path: '/audit',
        component: Step,
        children: [
            {
                path: 'stock-orders',
                name: 'audit.stock-orders',
                component: FrontList,
                meta: {
                    roles: ['Retail Call Center']
                },
                props: {
                    slug: 'stock-orders',
                    singular: 'stock order',
                    plural: 'stock orders',
                    icon: 'shopping_cart',
                    columnsDef: 'auditStockOrderColumns',
                    detailComp: 'stock-order-detail',
                }
            }]
    },

    // Catch all
    {
        path: '*',
        component: require('../pages/errors/404.vue')
    }
]

function makeCRUDsRoutes(path, resources, meta) {
    let routes = []
    resources.forEach(resource => {
        var parts = resource.split('\\').map(part => changeCase.paramCase(part))
        var slug = parts.join('/')
        var name = parts.join('.')
        var baseRoute = `${path}.${name}`
        routes.push({
            path: slug,
            name: `${baseRoute}.index`,
            component: List,
            meta,
            props: {slug, baseRoute, activateMeta: path.includes('backoffice') && !name.includes('stock-order')}
        })
        routes.push({
            path: `${slug}/form`,
            name: `${baseRoute}.create`,
            component: AutoForm,
            meta,
            props: {slug, baseRoute}
        })
        routes.push({
            path: `${slug}/form/:id`,
            name: `${baseRoute}.edit`,
            component: AutoForm,
            meta,
            props: {slug, baseRoute}
        })
    })
    return routes
}



// WEBPACK FOOTER //
// ./resources/assets/js/router/routes.js